// @flow

import '@babel/polyfill';
import 'custom-event-polyfill';
import 'core-js/web/url-search-params';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

ReactDOM.render(<App />, document.getElementById('de-exte-ante-cost-calculator-app'));
